import CourseExpiredModal from './CourseExpiredModal';

export default CourseExpiredModal;
